import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { getAuth } from "firebase/auth";




export default function ProjectTasksCard({ projectId }) {
  const [loading, setLoading] = useState(true);
  const [tasks, setTasks] = useState([]);
  const [editingTask, setEditingTask] = useState(null);
const [saving, setSaving] = useState(false);
const [editForm, setEditForm] = useState({
  title: "",
  description: "",
  status: "todo",
  priority: "normal",
  due_at: "",
});
const updateProjectTask = async (taskId, payload) => {
  const auth = getAuth();
  const user = auth.currentUser;
  if (!user) throw new Error("Not authenticated");

  const token = await user.getIdToken();

  const res = await axios.put(
    `https://modularobjects.com/checkout/api/project/tasks/${taskId}`,
    payload,
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );

  return res.data;
};

const location = useLocation();
const params = new URLSearchParams(location.search);
const highlightedTaskId = params.get("taskId");

useEffect(() => {
  if (!highlightedTaskId) return;

  const el = document.getElementById(`task-${highlightedTaskId}`);
  if (el) {
    el.scrollIntoView({ behavior: "smooth", block: "center" });
  }
}, [highlightedTaskId, tasks]);

function getStatusBadgeClass(status) {
  switch (status) {
    case "todo":
      return "bg-gray-100 text-gray-700 border-gray-200 dark:bg-neutral-800 dark:text-neutral-300 dark:border-neutral-700";
    case "in_progress":
      return "bg-blue-50 text-blue-700 border-blue-200 dark:bg-blue-950/30 dark:text-blue-300 dark:border-blue-900";
    case "blocked":
      return "bg-red-50 text-red-700 border-red-200 dark:bg-red-950/30 dark:text-red-300 dark:border-red-900";
    case "done":
      return "bg-green-50 text-green-700 border-green-200 dark:bg-green-950/30 dark:text-green-300 dark:border-green-900";
    case "cancelled":
      return "bg-neutral-100 text-neutral-700 border-neutral-200 dark:bg-neutral-800 dark:text-neutral-300 dark:border-neutral-700";
    default:
      return "bg-gray-100 text-gray-700 border-gray-200 dark:bg-neutral-800 dark:text-neutral-300 dark:border-neutral-700";
  }
}

function getPriorityBadgeClass(priority) {
  switch (priority) {
    case "low":
      return "bg-gray-100 text-gray-700 border-gray-200 dark:bg-neutral-800 dark:text-neutral-300 dark:border-neutral-700";
    case "normal":
      return "bg-slate-100 text-slate-700 border-slate-200 dark:bg-slate-900/40 dark:text-slate-300 dark:border-slate-800";
    case "high":
      return "bg-orange-50 text-orange-700 border-orange-200 dark:bg-orange-950/30 dark:text-orange-300 dark:border-orange-900";
    case "urgent":
      return "bg-red-50 text-red-700 border-red-200 dark:bg-red-950/30 dark:text-red-300 dark:border-red-900";
    default:
      return "bg-gray-100 text-gray-700 border-gray-200 dark:bg-neutral-800 dark:text-neutral-300 dark:border-neutral-700";
  }
}

function isOverdue(task) {
  if (!task?.due_at) return false;
  if (task?.status === "done" || task?.status === "cancelled") return false;

  const due = new Date(task.due_at);
  const now = new Date();

  return !Number.isNaN(due.getTime()) && due < now;
}

function getStageBadgeClass(stageKey) {
  switch (stageKey) {
    case "order":
      return "bg-slate-100 text-slate-700 border-slate-200 dark:bg-slate-900/40 dark:text-slate-300 dark:border-slate-800";
    case "design":
      return "bg-indigo-50 text-indigo-700 border-indigo-200 dark:bg-indigo-950/30 dark:text-indigo-300 dark:border-indigo-900";
    case "documentation":
      return "bg-blue-50 text-blue-700 border-blue-200 dark:bg-blue-950/30 dark:text-blue-300 dark:border-blue-900";
    case "material":
      return "bg-amber-50 text-amber-700 border-amber-200 dark:bg-amber-950/30 dark:text-amber-300 dark:border-amber-900";
    case "assembly":
      return "bg-teal-50 text-teal-700 border-teal-200 dark:bg-teal-950/30 dark:text-teal-300 dark:border-teal-900";
    case "transport":
      return "bg-cyan-50 text-cyan-700 border-cyan-200 dark:bg-cyan-950/30 dark:text-cyan-300 dark:border-cyan-900";
    case "installation":
      return "bg-green-50 text-green-700 border-green-200 dark:bg-green-950/30 dark:text-green-300 dark:border-green-900";
    default:
      return "bg-gray-100 text-gray-700 border-gray-200 dark:bg-neutral-800 dark:text-neutral-300 dark:border-neutral-700";
  }
}

async function autoAssignTask(taskId) {
  try {
    setSaving(true);

    const auth = getAuth();
    const user = auth.currentUser;
    if (!user) throw new Error("Not authenticated");

    const token = await user.getIdToken();

    const res = await axios.post(
      `https://modularobjects.com/checkout/api/project/tasks/${taskId}/auto-assign`,
      {},
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    console.log("AUTO ASSIGN RESULT:", res.data);

    await load();
  } catch (err) {
    console.error("Auto assign failed:", err);
    alert(err?.response?.data?.error || err.message || "Auto assign failed");
  } finally {
    setSaving(false);
  }
}

async function quickUpdate(taskId, newStatus) {
  try {
    setSaving(true);

    await updateProjectTask(taskId, {
      status: newStatus,
    });

    await load();
  } catch (err) {
    console.error("Quick update failed:", err);
    alert(err?.response?.data?.error || err.message || "Update failed");
  } finally {
    setSaving(false);
  }
}

function fmtDate(value) {
  if (!value) return "-";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return value;
  return d.toLocaleDateString("sr-RS");
}

function toDateInput(value) {
  if (!value) return "";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "";
  return d.toISOString().slice(0, 10);
}

async function handleSaveTask() {
  try {
    setSaving(true);
    await updateProjectTask(editingTask.id, editForm);
    setEditingTask(null);
    await load();
  } catch (err) {
    console.error("Failed to update task:", err);
    alert(err?.response?.data?.error || err.message || "Failed to update task.");
  } finally {
    setSaving(false);
  }
}


function openEdit(task) {
  setEditingTask(task);
  setEditForm({
    title: task.title || "",
    description: task.description || "",
    status: task.status || "todo",
    priority: task.priority || "normal",
    due_at: toDateInput(task.due_at),
  });
}

  async function load() {
    try {
      setLoading(true);

      const auth = getAuth();
      const user = auth.currentUser;
      if (!user || !projectId) return;

      const token = await user.getIdToken();

      const res = await axios.get(
        `https://modularobjects.com/checkout/api/project/${projectId}/tasks`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      setTasks(res.data?.items || res.data?.data || []);
    } catch (err) {
      console.error("Failed to load project tasks:", err);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    if (projectId) load();
  }, [projectId]);

  return (
    <div className="bg-white dark:bg-neutral-900 rounded-2xl border border-gray-200 dark:border-neutral-700 shadow-sm p-4 space-y-4">
      <div>
        <h2 className="text-lg font-semibold text-black dark:text-white">
          Project Tasks
        </h2>
        <p className="text-sm text-gray-500 dark:text-neutral-400">
          Auto-generated and manual tasks for this project.
        </p>
      </div>

      {loading ? (
        <div className="text-sm text-gray-500 dark:text-neutral-400">
          Loading tasks...
        </div>
      ) : tasks.length === 0 ? (
        <div className="text-sm text-gray-500 dark:text-neutral-400">
          No tasks yet.
        </div>
      ) : (
        <div className="space-y-3">
          {tasks.map((task) => (
            <div
  id={`task-${task.id}`}
  key={task.id}
  className={`border rounded-xl p-4 transition ${
    String(highlightedTaskId) === String(task.id)
      ? "border-yellow-400 bg-yellow-50 dark:bg-yellow-900/20 dark:border-yellow-500 shadow-md"
      : "border-gray-200 dark:border-neutral-700"
  }`}
>
              <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3">
                <div>
                  <div className="font-medium text-black dark:text-white">
                    {task.title}
                  </div>
                  
                </div>

                <div className="flex flex-wrap items-center gap-2 mt-2">
  <span
    className={`px-2 py-1 rounded-full border text-xs font-medium ${getStageBadgeClass(task.stage_key)}`}
  >
    {task.stage_key || "-"}
  </span>

  <span
    className={`px-2 py-1 rounded-full border text-xs font-medium ${getStatusBadgeClass(task.status)}`}
  >
    {task.status || "todo"}
  </span>

  <span
    className={`px-2 py-1 rounded-full border text-xs font-medium ${getPriorityBadgeClass(task.priority)}`}
  >
    {task.priority || "normal"}
  </span>

  {isOverdue(task) && (
    <span className="px-2 py-1 rounded-full border text-xs font-medium bg-red-50 text-red-700 border-red-200 dark:bg-red-950/30 dark:text-red-300 dark:border-red-900">
      overdue
    </span>
  )}
</div>

                <div className="flex items-center gap-2 flex-wrap">
  {task.status === "todo" && (
    <button
      disabled={saving}
      onClick={() => quickUpdate(task.id, "in_progress")}
      className="px-3 py-1 rounded-lg border border-gray-300 dark:border-neutral-700 text-sm bg-white dark:bg-neutral-900 text-black dark:text-white disabled:opacity-60"
    >
      Start
    </button>
  )}

  {task.status === "in_progress" && (
    <button
      disabled={saving}
      onClick={() => quickUpdate(task.id, "done")}
      className="px-3 py-1 rounded-lg border border-gray-300 dark:border-neutral-700 text-sm bg-white dark:bg-neutral-900 text-black dark:text-white disabled:opacity-60"
    >
      Complete
    </button>
  )}
  
<button
  disabled={saving}
  onClick={() => autoAssignTask(task.id)}
  className="px-3 py-1 rounded-lg border border-gray-300 dark:border-neutral-700 text-sm bg-white dark:bg-neutral-900 text-black dark:text-white disabled:opacity-60"
>
  Auto assign
</button>

  <button
    onClick={() => openEdit(task)}
    className="px-3 py-1 rounded-lg border border-gray-300 dark:border-neutral-700 text-sm bg-white dark:bg-neutral-900 text-black dark:text-white"
  >
    Edit
  </button>
</div>


              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-3 mt-3 text-sm">
                <div className="text-gray-600 dark:text-neutral-300">
                  <span className="text-gray-500 dark:text-neutral-400">Due:</span>{" "}
                  {fmtDate(task.due_at)}
                </div>
                <div className="text-gray-600 dark:text-neutral-300">
  <span className="text-gray-500 dark:text-neutral-400">Position:</span>{" "}
  {task.assigned_position_title || task.assigned_position_id || "-"}
</div>
                <div className="text-gray-600 dark:text-neutral-300">
  <span className="text-gray-500 dark:text-neutral-400">User:</span>{" "}
  {task.assigned_user_name || task.assigned_user_email || task.assigned_user_id || "-"}
</div>
              </div>

              
            </div>
          ))}
        </div>
      )}

{editingTask && (
  <div className="fixed inset-0 bg-black/30 flex items-center justify-center z-50 p-4">
    <div className="bg-white dark:bg-neutral-900 rounded-2xl shadow-xl w-full max-w-2xl p-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-xl font-semibold text-black dark:text-white">Edit task</h3>
        <button
          onClick={() => setEditingTask(null)}
          className="text-gray-500 dark:text-neutral-400"
        >
          ✕
        </button>
      </div>

      <div className="space-y-4">
        <input
          className="w-full px-3 py-2 rounded-xl border border-gray-300 dark:border-neutral-700 bg-white dark:bg-neutral-900 text-black dark:text-white"
          value={editForm.title}
          onChange={(e) => setEditForm((s) => ({ ...s, title: e.target.value }))}
          placeholder="Task title"
        />

        <textarea
          className="w-full min-h-[120px] px-3 py-2 rounded-xl border border-gray-300 dark:border-neutral-700 bg-white dark:bg-neutral-900 text-black dark:text-white"
          value={editForm.description}
          onChange={(e) => setEditForm((s) => ({ ...s, description: e.target.value }))}
          placeholder="Description"
        />

        <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
          <select
            className="w-full px-3 py-2 rounded-xl border border-gray-300 dark:border-neutral-700 bg-white dark:bg-neutral-900 text-black dark:text-white"
            value={editForm.status}
            onChange={(e) => setEditForm((s) => ({ ...s, status: e.target.value }))}
          >
            <option value="todo">Todo</option>
            <option value="in_progress">In progress</option>
            <option value="blocked">Blocked</option>
            <option value="done">Done</option>
            <option value="cancelled">Cancelled</option>
          </select>

          <select
            className="w-full px-3 py-2 rounded-xl border border-gray-300 dark:border-neutral-700 bg-white dark:bg-neutral-900 text-black dark:text-white"
            value={editForm.priority}
            onChange={(e) => setEditForm((s) => ({ ...s, priority: e.target.value }))}
          >
            <option value="low">Low</option>
            <option value="normal">Normal</option>
            <option value="high">High</option>
            <option value="urgent">Urgent</option>
          </select>

          <input
            type="date"
            className="w-full px-3 py-2 rounded-xl border border-gray-300 dark:border-neutral-700 bg-white dark:bg-neutral-900 text-black dark:text-white"
            value={editForm.due_at}
            onChange={(e) => setEditForm((s) => ({ ...s, due_at: e.target.value }))}
          />
        </div>

        <div className="flex justify-end gap-3">
          <button
            type="button"
            onClick={() => setEditingTask(null)}
            className="px-4 py-2 rounded-xl border border-gray-300 dark:border-neutral-700 bg-white dark:bg-neutral-900 text-black dark:text-white"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={handleSaveTask}
            disabled={saving}
            className="px-4 py-2 rounded-xl bg-black text-white"
          >
            {saving ? "Saving..." : "Save"}
          </button>
        </div>
      </div>
    </div>
  </div>
)}

    </div>
    
  );
}